import React from "react";
import { useField, useFormikContext } from "formik";
import Select, { components } from "react-select";
import FieldFeedback, { useFieldFeedback } from "./FieldFeedback";

// react-select 3 does not forward arbitrary aria props to its input.
const FeedbackSelectInput = (props) => (
  <components.Input
    {...props}
    aria-invalid={props.selectProps["aria-invalid"]}
    aria-describedby={props.selectProps["aria-describedby"]}
  />
);

const AASelectInput = ({
  label,
  hint,
  withEmptyOption = true,
  boolean = false,
  options = [],
  isFieldValueObject,
  wrapperClassName = '',
  ...props
}) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  const feedback = useFieldFeedback(props, meta.error, hint);

  const onChange = selection => {
    let value = '';

    if (isFieldValueObject) value = selection;
    else if (Array.isArray(selection)) value = selection.map((s) => s.value);
    else value = (selection === null) ? null : selection.value;
  
    setFieldValue(props.name, value);
  }

  if (boolean) {
    options = [
      { value: true, label: "Да" },
      { value: false, label: "Нет" },
    ];
  }

  // Поиск значения в опциях
  const findValue = (val) => options.find((option) => option.value === val);

  const getValue = () => {
    if (isFieldValueObject) return field.value;

    if (Array.isArray(field.value)) return field.value.map(findValue);

    return findValue(field.value);
  }

  return (
    <li className={wrapperClassName} data-signal-field="" data-signal-label={label} data-signal-name={props.name}>
      {label && <label htmlFor={feedback.id} className="custom_label">{label}</label>}
      <Select
        {...field}
        {...props}
        id={`${feedback.id}-container`}
        inputId={feedback.id}
        aria-invalid={feedback["aria-invalid"]}
        aria-describedby={feedback["aria-describedby"]}
        classNamePrefix="signal-select"
        components={{ Input: FeedbackSelectInput, ...props.components }}
        options={options}
        value={props.value || getValue()}
        onBlur={field.onBlur(field.name)}
        onChange={onChange}
      />
      <FieldFeedback id={feedback.id} error={meta.error} hint={hint} />
    </li>
  );
};

export default AASelectInput;
